import type { FreelancerKVKInformationPageLocales } from '../types';

const freelancerKVKInformationPageLocales: FreelancerKVKInformationPageLocales =
  {
    checkKVKInformation:
      'For this KVK number, we found below information. Review this carefully.',
    companyDataSaved: 'Company data successfully saved!',
    enterKVKNumberMessage:
      'Enter your Chamber of Commerce number below. Based on that information, we retrieve other data from your company.',
    errorBillingAddressEmpty:
      'This field cannot be empty. Select a billing address.',
    errorCompanyNameEmpty:
      'This field cannot be empty. Select a company name for billing.',
    errorFetchingKVKInformation:
      'Something went wrong while fetching the KVK information. Check if you entered a correct KVK number.',
    errorKVKAlreadyExists:
      'There is already an account with this KVK number. Contact info@tadaah.nl if you do not have access to that account',
    errorKVKNumberEmpty:
      'KVK nummer cannot be empty. You can find your KVK number in your correspondence with the KVK',
    errorKVKNumberLength: 'KVK numbers are always {{length}} numbers',
    errorTooManyRequests:
      'KVK information was retrieved too many times. Try again later',
    fullName: 'Full name',
    informationIncorrectInfo:
      'We are recieving this information from the KVK. If this information is incorrect, please contact the KVK.',
    isInformationIncorrect: 'Is your company information incorrect?',
    kvkInformationDialogdialogFirstInstruction: `To be able to work as a freelancer in childcare, you must be registered with the Chamber of Commerce and be registered with the work you will perform (including SBI codes 88.91.1 and 86.91.3). 
    Enter your Chamber of Commerce number on the next page. Your data will then be automatically retrieved and filled in. Check this information.
    Is your data incorrect? Please contact the Chamber of Commerce to change your details.Your Chamber of Commerce number is stated on the proof of your registration with the Chamber of Commerce.`,
    kvkInformationIncomplete:
      'One or multiple fields have not been filled, but are required to complete your registration. Please contact the KVK to add or correct this information. For now, you can skip this step.',
    kvkInformationSuccessfullyFetched:
      'KVK information has been successfully fetched.',
    kvkNumber: 'KVK number',
    refetchData: 'refetch information',
    registrationAddress: 'Billing Address',
    registrationAddressPlaceholder:
      'Street name, house number, place of residence',
    sbiCodes: 'SBI-code(s)',
    title: 'KVK registration',
    tradeName: 'Company Name',
  };

export default freelancerKVKInformationPageLocales;
